// 计算太阳能板一天发电量
// export const calcEnergyGeneration = (power: number, n: number) => Math.round(((power * 100) / 1000) * 6 * n) / 100;
export const calcEnergyGeneration = (power: number, n: number, locale: string) =>
    Math.round(((power * 100) / 1000) * (['eu', 'uk', 'de', 'fr', 'it', , 'es'].includes(locale) ? 5 : ['jp'].includes(locale) ? 4 : 6) * n) / 100;
// 计算存储量
export const calcEnergyStorage = (key: string) => {
    const ProductStorage: any = {
        dpu: 6,
        dp3: 4,
        dp3plus: 1.02,
        deltapro: 3.6,
        deltapro_2: 7.2,
        deltapro3: 4,
        river2: 0.25,
        river2max: 0.51,
        river2pro: 0.77,
        river3: 0.25,
        river3max: 0.57,
        river3plus: 0.28,
        river3pro: 0.77,
        delta2: 1.04,
        delta2max: 2.05,
        T200: 0.19,
        T300: 0.28,
        delta3ultraplus: 3.072,
        delta3ultra: 3.072,
        dp3classic: 1.024,
        delta3max: 2.048,
        delta3maxplus: 2.048,
    };
    return ProductStorage[key] || 0;
};

// 推荐选择的太阳能板数量
export const getRecommand = (product: string, solar: string) => {
    const MAP: any = {
        dpu: {
            '400w_rigid': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            '400w': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        },
        dp3: {
            '400w': [1, 2, 3, 4, 5, 6],
            '220w': [1, 2, 3, 4, 5, 6],

            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
        },
        dp3plus: {
            '110w': [1, 2, 3, 4, 5, 6, 7, 8, 9],
            '160w': [1, 2, 3, 4, 5, 6],
            '220w': [1, 2, 3, 4],
        },
        deltapro: {
            '220w': [1, 2, 3, 4, 5, 6, 7],
            '400w': [1, 2, 3, 4],
        },
        deltapro_2: {
            '400w_rigid': [1, 2, 3, 4, 5, 6, 7, 8],
        },
        deltapro3: {
            '220w': [1, 2, 3, 4, 5, 6, 7],
            '400w': [1, 2, 3],
        },
        delta2max: {
            '400w_rigid': [1, 2, 3, 4, 5, 6, 7, 8],
            '100w_rigid': [4, 5],
            '110w': [2, 3, 4],
            '160w': [1, 2, 3, 4],
            '220w': [1, 2, 3, 4],
        },
        delta2: {
            '110w': [1, 2, 4],
            '160w': [1, 2],
            '220w': [1, 2],
        },
        river2: {
            '60w': [1],
            '110w': [1],
        },
        river2max: {
            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
            '220w': [1],
        },
        river2pro: {
            '45w': [1, 2, 3, 4, 5],
            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
            '220w': [1],
        },
        river3: {
            '45w': [1, 2, 3],
            '60w': [1, 2],
            '110w': [1],
        },
        river3plus: {
            '45w': [1, 2, 3, 4, 5],
            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
            '220w': [1],
        },
        river3max: {
            '45w': [1, 2, 3, 4, 5],
            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
            '220w': [1],
        },
        river3pro: {
            '45w': [1, 2, 3, 4, 5],
            '60w': [1, 2],
            '110w': [1, 2],
            '160w': [1],
            '220w': [1],
        },
        T300: {
            '45w': [1],
            '60w': [1],
        },
        delta3ultraplus: {
            '400w': [1, 2],
            '220w': [1, 2],
        },
        delta3ultra: {
            '400w': [1, 2],
            '4*125w': [1],
            '2*220w': [1],
            '2*400w': [1],
            '220w': [1, 2],
        },
        dp3classic: {
            '110w': [1, 2, 3, 4],
            '220w': [1, 2],
        },
        delta3max: {
            '220w': [1, 2],
            '400w': [1],
        },
        delta3maxplus: {
            '400w': [1],
            '4*125w': [1],
            '220w': [1],
        },
    };
    return MAP[product][solar];
};
